import {Reducer} from 'redux';
import initialState from './state';
import {IReduxAction, IReduxAppState} from '../../@interfaces';
import {
    APP_BOOTED,
    APP_BOOTING,
    APP_CLEAR_FATAL_ERROR,
    APP_LOADED,
    APP_LOADING,
    APP_SET_FATAL_ERROR,
    APP_SET_WORK_SCHEDULE
} from './constants';

const reducer: Reducer = (state: IReduxAppState = initialState, action: IReduxAction): IReduxAppState => {
    switch (action.type) {
        case APP_BOOTING:
            return {...state, booting: true, booted: false};

        case APP_BOOTED:
            return {...state, booting: false, booted: true};

        case APP_LOADING:
            return {...state, loading: true, loaded: false};

        case APP_LOADED:
            return {...state, loading: false, loaded: true};

        case APP_SET_FATAL_ERROR:
            return {...state, fatalError: action.payload};

        case APP_CLEAR_FATAL_ERROR:
            return {...state, fatalError: undefined};

        case APP_SET_WORK_SCHEDULE:
            return {...state, workSchedule: action.payload.schedule};

        default:
            break;
    }

    return state;
};

export default reducer;
